import TYPES from './types';
export default {
    [TYPES.HMS]: {
        en: ['h', 'm', 's'],
        id: ['j', 'mnt', 'dtk'],
        my: ['j', 'm', 's'],
        th: ['ชม.', 'น.', 'วิ'],
        vn: ['h', 'm', 's'],
    },
    [TYPES.DHM]: {
        en: ['day(s)', 'h', 'm'],
        id: ['h', 'j', 'mnt'],
        my: ['h', 'j', 'm'],
        th: ['ว', 'ชม.', 'น.'],
        vn: ['ngày ', 'h', 'm'],
    },
};
